import { IDestroyOptions } from "pixi.js";
import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import { BaseView } from "../../../../../scene/viewable/BaseView";
import { PromiseCompletionSource } from "../../../../../shared/async/PromiseCompletionSource";
import { VariableSaver } from "../../../../../tools/variableSaver/VariableSaver";
import { IGuestModel } from "../../../common/models/IGuestModel";
import { IAnalyticProviderWrapper } from "../../../../../analytics/IAnalyticProviderWrapper";
import { VirtualScreenEvent } from "../../../../../analytics/events/VirtualScreenEvent";
import { TickerDelay } from "by/gamefactory/tools/TickerDelay";

export class CookiesPopupView extends BaseView<void> {
    private readonly analyticsProvider: IAnalyticProviderWrapper;
    private readonly canvasScaler: ICanvasScaler;
    private readonly variableSaver: VariableSaver;
    private readonly guestModel: IGuestModel;

    public constructor(operationControls: PromiseCompletionSource<void>,
        variableSaver: VariableSaver,
        canvasScaler: ICanvasScaler,
        guestModel: IGuestModel,
        analyticsProvider: IAnalyticProviderWrapper
    ) {
        super(operationControls);
        this.variableSaver = variableSaver;
        this.canvasScaler = canvasScaler;
        this.guestModel = guestModel;
        this.analyticsProvider = analyticsProvider;
    }

    public async start(): Promise<void> {
        // for disable clicking through letsGo button on preloader
        TickerDelay.delay(100);
        document.dispatchEvent(new Event('show-settings'));
        const saveButton = document.getElementById("cookies-settings-save-button");
        saveButton.addEventListener("click", () => {
            this.variableSaver.saveBoolean(`cookies,${this.guestModel.id.value}`, true);
            this.operationControls.complete();
        });
        const acceptButton = document.getElementById("cookies-popup-accept-button");
        acceptButton.addEventListener("click", () => {
            this.variableSaver.saveBoolean(`cookies,${this.guestModel.id.value}`, true);
            this.analyticsProvider.registerGoogleEvent(new VirtualScreenEvent("Accept Cookies", this.analyticsProvider.currentEventIndex));
            this.operationControls.complete();
        });
        const settingsButton = document.getElementById("cookies-popup-settings-button");
        settingsButton.addEventListener("click", () => {
            this.analyticsProvider.registerGoogleEvent(new VirtualScreenEvent("Change Settings open", this.analyticsProvider.currentEventIndex));
        });
    };

    public destroy(options?: boolean | IDestroyOptions): void {
        super.destroy(options);
    }
}